import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core'
import { NgStyle } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import { TranslateService } from '@ngx-translate/core'
import { MinuteTimelineSegment } from '../types/template.types'
import { TimestampPipe } from '../../timestamp.pipe'

const TIMELINE_SEGMENT_MIN_WIDTH_PERCENT = 4

@Component({
  selector: 'app-timeline-bar',
  standalone: true,
  imports: [NgStyle, MatTooltip],
  templateUrl: './timeline-bar.component.html',
  styleUrl: './timeline-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [TimestampPipe],
})
export class TimelineBarComponent {
  @Input({ required: true })
  segments!: MinuteTimelineSegment[]

  private translateService = inject(TranslateService)
  private timestampPipe = inject(TimestampPipe)

  get tooltip(): string {
    return this.segments
      .map((segment, index) => {
        const start = this.timestampPipe.transform(segment.startSeconds)
        const end = this.timestampPipe.transform(segment.endSeconds)
        return `${this.translateService.instant('TEMPLATES.EDITOR.DISCUSSION_SEGMENT')} ${index + 1}: ${start} - ${end}`
      })
      .join('\n')
  }

  getSegmentStyle(segment: MinuteTimelineSegment): { left: string; width: string } {
    const minWidth = TIMELINE_SEGMENT_MIN_WIDTH_PERCENT
    // Ensure left position allows the full min width to be visible
    const left = Math.min(segment.startPercent, 100 - minWidth)
    // Calculate width, ensuring minimum but not overflowing
    const width = Math.min(Math.max(segment.widthPercent, minWidth), 100 - left)
    return {
      left: `${left}%`,
      width: `${width}%`,
    }
  }
}
